import { useEffect, useState } from "react";
import { api, errMsg } from "../../lib/api";
import { Loading } from "../../components/PageHeader";
import { AdminTitle, Pill, ErrorBox } from "./AdminLayout";

const ENTITIES = ["", "user", "role", "product", "media", "setting", "site_content"];
const TONE = { delete: "red", create: "green", price_change: "gold" };

export default function AuditLog() {
  const [items, setItems] = useState(null);
  const [entity, setEntity] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/admin/audit", { params: { entity: entity || undefined } }).then((r) => { setItems(r.data); setErr(""); }).catch((e) => setErr(errMsg(e)));
  }, [entity]);
  return (
    <div data-testid="admin-audit">
      <AdminTitle eyebrow="History" title="Audit log">
        <select className="wb-input !w-44" value={entity} onChange={(e) => setEntity(e.target.value)} data-testid="audit-entity-filter">
          {ENTITIES.map((e) => <option key={e} value={e}>{e ? e.replace("_", " ") : "All entities"}</option>)}
        </select>
      </AdminTitle>
      {err ? <ErrorBox msg={err} /> : !items ? <Loading /> : items.length === 0 ? <p className="py-10 muted" data-testid="audit-empty">No activity yet.</p> : (
        <div className="border-t wb-line">
          {items.map((a) => (
            <div key={a.id} className="grid gap-2 border-b wb-line py-3 text-sm md:grid-cols-[170px_200px_130px_1fr]" data-testid="audit-row">
              <span className="font-mono text-xs muted">{new Date(a.at).toLocaleString()}</span>
              <span className="truncate">{a.actor_email}</span>
              <span><Pill tone={TONE[a.action] || "muted"}>{a.action.replace("_", " ")}</Pill> <span className="text-xs muted">{a.entity}</span></span>
              <span className="muted">{a.summary}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
